import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { TipoFreteSelectComponent } from './tipo-frete-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TipoFreteSelectComponent
    ],
    exports: [
        TipoFreteSelectComponent
    ]
})
export class TipoFreteSelectModule { }
